import { useMemo } from "react"

import { Pages } from "modules/BookingCommon/common/constants"
import { TIME_REQUEST_STATUSES, LOADING_TEXT } from "utils/constants"
import { HeadingContainer, HeadingEmojiWithText, PsyAvatar } from "modules/BookingCommon/components"
import { BookingStatusMap } from "utils/interfaces"
import {
    createdTimeRequestLoader,
    createdBookingLoader,
    createdDepositLoader,
} from "modules/BookingCommon/common/queries"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useService } from "modules/Booking/common/hooks"
import { useGetCurrentPage } from "modules/Booking/common/hooks/useGetCurrentPage"
import { depositStatusesSuccess } from "modules/Booking/common/constants/depositStatuses"
import { sessionNounDeclensionByNumeral } from "utils/infrastructure/wording-utils"

function AvatarWithText() {
    const [{ psy, isOnline }] = useBookingContext()
    const { onlineAndOfflineAvailable } = useService()
    const currentPage = useGetCurrentPage()

    const title = useMemo(() => {
        if (currentPage === Pages.SESSION_DATE && !onlineAndOfflineAvailable) {
            if (isOnline) {
                return "Запись на онлайн-сессию"
            } else {
                return "Запись на личную сессию"
            }
        }
        return "Запись к психологу"
    }, [currentPage, isOnline, onlineAndOfflineAvailable])

    return (
        <>
            <PsyAvatar psy={psy} />
            <div className="booking-heading-text">{title}</div>
        </>
    )
}

export function Heading() {
    const [{ isLoading }] = useBookingContext()

    const bookingHash = createdBookingLoader.getHash()
    const { data: bookingDetails } = createdBookingLoader.useGet(bookingHash)
    const bookingStatus = bookingDetails?.status
    const bookingIsLoading = createdBookingLoader.useIsLoading()
    const timeRequestHash = createdTimeRequestLoader.getHash()
    const { data: timeRequestResponse } = createdTimeRequestLoader.useGet(timeRequestHash)
    const timeRequestStatus = timeRequestResponse?.status
    const depositHash = createdDepositLoader.getHash()
    const { data: depositInfo } = createdDepositLoader.useGet(depositHash)
    const depositStatus = depositInfo?.status

    return (
        <HeadingContainer>
            {() => {
                if (bookingIsLoading || isLoading) return LOADING_TEXT
                if (depositStatus && depositStatusesSuccess.includes(depositStatus)) {
                    return (
                        <HeadingEmojiWithText
                            text={`Вы записались на 1 из ${depositInfo.configuration.session_amount} ${sessionNounDeclensionByNumeral(depositInfo.configuration.session_amount)}`}
                        />
                    )
                }
                return bookingStatus === BookingStatusMap.PAID ||
                    timeRequestStatus === TIME_REQUEST_STATUSES.PAID ||
                    timeRequestStatus === TIME_REQUEST_STATUSES.WAITING_FOR_RESPONSE ? (
                    <HeadingEmojiWithText text="Вы записались к психологу" />
                ) : (
                    <AvatarWithText />
                )
            }}
        </HeadingContainer>
    )
}
